import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AreaEditComponent } from '@fi-app/area/area-edit/area-edit.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { AreaService } from '@fi-app/area/area.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiTimeZonesService } from '@fi-shared/fi-shared-services/fi-time-zones.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAreaAddStateResolve_countries } from '@fi-app/area/states/area-add-state';
import { FiCountryHelperService } from '@fi-shared/fi-contacts/fi-countries-select/country-helper.service';

export const FiAreaEditState: Ng2StateDeclaration = {
    name: FiStateNames.Area.Edit,
    url: '/:Id/Edit',
    views: {
        '@': {
            component: AreaEditComponent,
        },
    },
    resolve: {
        area: [FiStateService, AreaService, Transition, FiAreaEditStateResolve_area],
        countries: [FiCountryHelperService, FiAreaAddStateResolve_countries],
        timeZones: [FiTimeZonesService, FiAreaEditStateResolve_timeZones],
        pageTitle: [PageTitleService, 'area', FiAreaEditStateResolve_pageTitle],
    },
};

export function FiAreaEditStateResolve_area(fiStateService: FiStateService, areaService: AreaService, tr: Transition) {
    return areaService.GetArea(fiStateService.getParams(tr).Id);
}

export function FiAreaEditStateResolve_timeZones(fiTimeZonesService: FiTimeZonesService) {
    return fiTimeZonesService.getTimeZones();
}

export function FiAreaEditStateResolve_pageTitle(ccmPageTitle: PageTitleService, area) {
    return ccmPageTitle.setTitleByItem(area);
}
